var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"operate-column"},_vm._l((_vm.computedProps.items),function(item){return _c(item.component,_vm._g(_vm._b({key:item.key,tag:"component"},'component',item.props,false),item.on),[_vm._v(" "+_vm._s(item.render())+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }